
























import { Component, Vue } from 'vue-property-decorator';
import { treatValue } from '@/utils/moneyTreatments';
import TextInput from '@/components/TextInput/TextInput.vue';
import Card from '@/components/Card/Card.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import BusinessService from '@/api/BusinessService';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';

@Component({
  components: {
    FlexButton,
    SideModalHeader,
    TextInput,
    Card,
    ContentContainer
  }
})
export default class Offer extends Vue {
  isLoading: boolean = true;
  lastUpdate: string = '';
  service: BusinessService = new BusinessService();
  usdCirculation: string = '';
  purchaseCoins: string = '';
  rewardedCoins: string = '';
  offerRedeemed: string = '';
  mounted() {
    this.updateStatistics();
    this.$hideLoader();
    this.getReports();
  }

  getReports() {
    this.$showLoaderWithLocker();
    this.service
      .getBasicReports()
      .then(res => {
        const { data } = res;
        this.usdCirculation = `${this.businessCurrency} ${data.usdCirculation}`;
        this.rewardedCoins = `${treatValue(data.rewardedCoins)}`;
        this.purchaseCoins = `${treatValue(data.purchaseCoins)}`;
        this.offerRedeemed = `${treatValue(data.offerRedeemed)}`;
        this.lastUpdate = new Date().toLocaleString();
      })
      .catch(() => {})
      .finally(() => {
        this.$hideLoader();
        this.isLoading = false;
      });
  }

  updateStatistics() {
    this.getReports();
  }

  get businessCurrency() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  get businessShorthand() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencyShorthand;
  }
}
